module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.9439/img/cms-free-signup.png"